var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M34.675 31.393l-.015-.025-6.986-10.217v-3.928a2.176 2.176 0 001.406-2.048A2.152 2.152 0 0026.958 13h-5.916a2.152 2.152 0 00-2.123 2.175 2.176 2.176 0 001.407 2.048v3.928l-7 10.242a2.413 2.413 0 00-.016 2.4A2.3 2.3 0 0015.333 35h17.333a2.3 2.3 0 002.024-1.2 2.415 2.415 0 00-.015-2.407zm-12.851-9.55a.849.849 0 00.128-.448v-4.878a.823.823 0 00-.813-.833h-.1a.509.509 0 010-1.018h5.916a.509.509 0 010 1.018h-.1a.823.823 0 00-.813.833v4.877c0 .158.044.313.127.448l3.343 5.358a7.557 7.557 0 01-2.858.3c-2.018-.243-3.455-2.013-5.6-2.221a5.634 5.634 0 00-1.42.077l2.19-3.513z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
